import ServerError from './serverError';

export default ServerError;